<template>
  <div>
      <SaleMaster addNew="/sales/sales-order/" type="SO" ></SaleMaster>
  </div>
</template>

<script>
import SaleMaster from './master.vue'
export default {

   components: { SaleMaster },

}
</script>

<style>

</style>